import * as z from 'zod'

import {
  AUSTRIAN_ZIP_CODE_REGEX,
  GERMAN_ZIP_CODE_REGEX,
  SupportedMarketKey,
} from '@nxt-insurance/constants'

import { getLocationStepContent } from '@flows/configs/common/locationUtils'
import { getAlphaNumeriCharactersValidation } from '@flows/configs/shared/validators'
import { t } from '@flows/core/i18n'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

const getZipCodeValidation = (market: SupportedMarketKey) => {
  const ZIP_CODE_VALIDATION = {
    [SupportedMarketKey.De]: z
      .string()
      .regex(GERMAN_ZIP_CODE_REGEX, t('sharedFlows_common:generic.errors.invalidZipCode')),
    [SupportedMarketKey.At]: z
      .string()
      .regex(AUSTRIAN_ZIP_CODE_REGEX, t('sharedFlows_common:generic.errors.invalidZipCode')),
  }
  return ZIP_CODE_VALIDATION[market]
}

export const getLocationSchema = (market: SupportedMarketKey) =>
  z.object({
    street: z.string().min(1),
    town: z.string().min(1),
    houseNumber: getAlphaNumeriCharactersValidation(),
    zip_code: getZipCodeValidation(market),
  })

const location = ({ market }: { market: SupportedMarketKey }) => {
  return {
    schema: getLocationSchema(market),
    stepContent: getLocationStepContent(market),
    nextStep: 'birthday',
    subFlow: SubFlow.Common,
  } as const satisfies AnyStepConfiguration
}

export default location
